import { render } from "./PricingSection.vue?vue&type=template&id=f1ba8bce&scoped=true"
import script from "./PricingSection.vue?vue&type=script&lang=js"
export * from "./PricingSection.vue?vue&type=script&lang=js"

import "./PricingSection.vue?vue&type=style&index=0&id=f1ba8bce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1ba8bce"]])

export default __exports__